import { render } from "./HistoricoAgente.vue?vue&type=template&id=6249f49f&scoped=true"
import script from "./HistoricoAgente.vue?vue&type=script&lang=js"
export * from "./HistoricoAgente.vue?vue&type=script&lang=js"

import "./HistoricoAgente.vue?vue&type=style&index=0&id=6249f49f&scoped=true&lang=css"

import exportComponent from "D:\\Documentos\\Cliqx\\worsapace_cliqx\\interagev2\\facilitabots.interagev2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6249f49f"]])

export default __exports__